import { inject, isDevMode } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GroupLinkService } from '@core/services/group-link.service';

export const eventLandingGuard: CanActivateFn = () => {
  if (isDevMode()) {
    return true;
  }

  const router = inject(Router);
  const groupLinkService = inject(GroupLinkService);
  router.navigate(groupLinkService.prependGroupLink(['seat-selection']));
  return false;
};
